import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import { colors } from 'src/utils/colors';

import { useSettingsContext } from '../settings';

const CButton = ({
  children,
  variant = 'contained',
  sx = {},
  onClick,
  type = 'button',
  href,
  target = '_blank',
  rel = 'noopener',
  disabled = false,
  ...other
}) => {
  const settings = useSettingsContext();

  const backgroundColor = settings?.themeMode === 'dark' ? colors?.secondary : colors?.primary;
  const hoverBackgroundColor =
    settings?.themeMode === 'dark' ? colors?.secondaryDark : colors?.primaryDark;

  return (
    <Button
      variant={variant}
      sx={{
        backgroundColor,
        '&:hover': { backgroundColor: hoverBackgroundColor },
        ...sx,
      }}
      onClick={onClick}
      type={type}
      href={href}
      target={href ? target : undefined}
      rel={href ? rel : undefined}
      disabled={disabled}
      {...other}
    >
      {children}
    </Button>
  );
};

CButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  sx: PropTypes.object,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CButton;
